import { settings } from "../../../customize/settings";
import { IBaseError } from "../../../interfaces/errors";
import { ICategoria } from "../../../interfaces/lotto/attributes/models";
import { IListResponse } from "../../../interfaces/rest";
import { getJWT } from "../../../lib/jwt";

const BASE_URL = `${settings.apiUrl}categoria`;

export const getCategoria = async (id: number): Promise<ICategoria> => {
	const url = `${BASE_URL}/${id}`;
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const jwt = getJWT();
	if (jwt) headers.append('Authorization', 'Bearer ' + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers: headers
	});
	const json: ICategoria | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as ICategoria;
}

export const getCategoriaList = async (): Promise<IListResponse<ICategoria>> => {
	const url = `${BASE_URL}/list`;
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const jwt = getJWT();
	if (jwt) headers.append('Authorization', 'Bearer ' + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers: headers
	});
	const json: IListResponse<ICategoria> | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IListResponse<ICategoria>;
}
